import { STACK_ENV } from '@/configs/stackEnvironment';
import type { FeatureFlagDefinition } from '@/utils/featureFlags';

export const FEATURE_FLAGS = {
  decisionsRoute: {
    description: 'Enable Decisions route on local/dev for Corning.',
    enabledStacks: [STACK_ENV.LocalDev, STACK_ENV.DevStack],
    enabledTenants: ['corning'],
  },
  enableForecastPlanGeneration: {
    description: 'Enable forecast demand plan generation controls in local development.',
    enabledStacks: [STACK_ENV.LocalDev],
    enabledTenants: ['corning'],
  },
  bonfireRoute: {
    description:
      'Enable the Bonfire admin tab (solutions, executions, model data, forecast explorer, leaderboard) on every stack and tenant.',
    enabledStacks: [STACK_ENV.LocalDev, STACK_ENV.DevStack, STACK_ENV.ProdStack],
  },
} as const satisfies Record<string, FeatureFlagDefinition>;

export type FeatureFlagKey = keyof typeof FEATURE_FLAGS;
